
















































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import SendMailDialogComponent from '@/components/SendMailDialogComponent.vue'
import { MailQueue } from '@/domain/Report'
import { Request } from '@/domain/Request'
import { SendMail } from '@/domain/SendMail'
import { WindowPosition } from '@/domain/WindowPosition'
import UnclaimedsService, { SerchConditon } from '@/service/UnclaimedsService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    CustomerSelectDialogComponent,
    PdfViewComponent,
    SendMailDialogComponent,
  },
})
export default class MemberUnclaimedList extends Mixins(GlobalMixin) {
  unclaimedsService = UnclaimedsService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "依頼日", value: "requestOn", width: "100px" },
          { text: "受付番号", value: "requestNo", width: "130px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検体名", value: "specimenName", width: "120px" },
          { text: "検体識別記号", value: "specimenId", width: "130px" },
          { text: "検査項目", value: "sumInfo.inspectionNames" },
          { text: "小計", value: "sumInfo.amount", align: "end", filterable: false, width: "100px" },
          { text: "消費税", value: "sumInfo.tax", align: "end", filterable: false, width: "100px" },
          { text: "見積金額", value: "sumInfo.totalAmount", align: "end", filterable: false, width: "100px" },
          { text: "報告書送付", value: "reportSend", align: "center", filterable: false, width: "120px" },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "80px" },
  ]
  list: Request[] = []
  selectItems: Request[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""

  mailSendRequestNos: string[] = []
  sendMail = new SendMail()

/**
   * 選択リストのバリデーション
   */
  get isValidate() {
    const keys = this.selectItems.map(x => `${x.customerInfo.customerPrefectureCode}:${x.customerInfo.customerCode}:${x.customerInfo.customerBranchNumber}:${x.agencyInfo.agencyPrefectureCode}:${x.agencyInfo.agencyCode}:${x.agencyInfo.agencyBranchNumber}:${x.requestType}`)
    const distinct = [...new Set(keys)]
    return distinct.length === 1
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.unclaimed.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.unclaimed.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.unclaimed.list.conditions", JSON.stringify(this.conditions))
    this.unclaimedsService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.selectItems = []
        this.mountedDataTable("tool.unclaimed.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: Request): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Request) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.requestNo) {
      this.$router.push(`/member/invoice/new?refs=${event.requestNo}`)
    }
    this.rowItemKey = event.requestNo
    this.rowItemClickTime = now
  }

  /**
   * 請求書作成
   */
  onInvoice() {
    const query = this.selectItems.map(x => x.requestNo)
        .join(",")
    this.$router.push("/member/invoice/new?refs=" + query)
  }
  
  /**
   * メール一括送信ボタンのクリック
   */
  onMail() {
    const requestNos = this.selectItems.map(x => x.requestNo)
    this.onSendMail(requestNos)
  }

  /**
   * メール送信ボタンのクリック
   */
  onSendMail(requestNos: string[]) {
    this.mailSendRequestNos = requestNos
    this.reportsService.generateMailTemplateByRequest(this.mailSendRequestNos)
      .then(x => {
        this.sendMail = x
        this.mailSendDialog = true
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信テンプレートの取得に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * メール送信
   */
  onSendMailed(event: SendMail) {
    this.showLoading()
    const mailQueue = new MailQueue({to: event.to, cc: event.cc, bcc: event.bcc, replyTo: event.replyTo, subject: event.subject, content: event.content, reportNos: event.reportNos})
    this.reportsService.mailQueuePush(mailQueue)
      .then(() => {
          this.list.filter(x => this.mailSendRequestNos.indexOf(x.requestNo) >= 0)
            .forEach(x => x.reportSendCount = x.reportCount)
          this.alert("メール送信しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.unclaimed.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.unclaimed.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.unclaimed.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
